import { render } from "./UserPreferencesView.vue?vue&type=template&id=1d2eae76&scoped=true"
import script from "./UserPreferencesView.vue?vue&type=script&lang=js"
export * from "./UserPreferencesView.vue?vue&type=script&lang=js"

import "./UserPreferencesView.vue?vue&type=style&index=0&id=1d2eae76&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2eae76"]])

export default __exports__